import React from "react";
import { formatTimeMMSS } from "@own-local/ad-utils/lib/formatter";
import "./styles.scss";

interface AudioPlayerProps {
  url?: string;
  name: string;
}

interface AudioPlayerState {
  currentTime: number;
  seekValue: number;
  isPlaying: boolean;
}

export default class App extends React.Component<
  AudioPlayerProps,
  AudioPlayerState
> {
  private audioPlayer: React.RefObject<HTMLAudioElement>;

  constructor(props) {
    super(props);
    this.audioPlayer = React.createRef();
    this.play = this.play.bind(this);
    this.pause = this.pause.bind(this);
    this.stop = this.stop.bind(this);
    this.onPlaying = this.onPlaying.bind(this);
    this.state = {
      currentTime: 0,
      seekValue: 0,
      isPlaying: false,
    };
  }

  play() {
    this.setState({ isPlaying: true });
    this.audioPlayer.current.play();
  }
  pause() {
    this.setState({ isPlaying: false });
    this.audioPlayer.current.pause();
  }
  stop() {
    this.setState({ isPlaying: false });
    this.audioPlayer.current.pause();
    this.audioPlayer.current.currentTime = 0;
  }
  onPlaying() {
    this.setState({
      currentTime: this.audioPlayer.current.currentTime,
    });
    this.setState({
      seekValue:
        (this.audioPlayer.current.currentTime /
          this.audioPlayer.current.duration) *
        100,
    });
    if (
      this.audioPlayer.current.currentTime == this.audioPlayer.current.duration
    ) {
      this.stop();
    }
  }

  getParsedDate(date) {
    var dd: any = date.getDate();
    var mm: any = date.getMonth() + 1;
    var yyyy = date.getFullYear();

    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    date = dd + "-" + mm + "-" + yyyy;
    return date.toString();
  }

  render() {
    const { currentTime, seekValue, isPlaying } = this.state;
    return (
      <div className="wrapper-audio">
        <div
          id="AudioPlayer"
          className="jp-jplayer audio jp-state-audio jp-state-idle jp-state-volume-high"
          draggable="false"
        >
          <audio
            className="jp-media"
            ref={this.audioPlayer}
            onTimeUpdate={this.onPlaying}
          >
            <source src={this.props.url} type="audio/mp3" />
            Your browser does not support the audio element.
          </audio>
          <div className="player jp-audio" aria-label="media player">
            <div className="jp-gui jp-interface">
              <div className="audio-info">
                <div className="line-one">{this.props.name}</div>
                <div className="line-two">
                  <span
                    className="mdi mdi-calendar"
                    style={{ marginRight: "7px", opacity: "0.8" }}
                  />
                  <span>{this.getParsedDate(new Date())}</span>
                  <span
                    className="mdi mdi-clock-outline"
                    style={{ margin: "0px 7px 0px 15px", opacity: "0.8" }}
                  />
                  <div className="jp-current-time">
                    {formatTimeMMSS(currentTime)}
                  </div>
                </div>
              </div>
              <div className="jp-controls">
                {!isPlaying && (
                  <button className="jp-play" onClick={this.play}>
                    <span className="mdi mdi-play-circle jp-play" />
                  </button>
                )}
                {isPlaying && (
                  <button className="jp-play" onClick={this.pause}>
                    <span className="mdi mdi-pause-circle jp-play" />
                  </button>
                )}
              </div>
              <div className="jp-progress">
                <div className="jp-seek-bar">
                  <div
                    className="jp-play-bar"
                    style={{ width: `${seekValue}%` }}
                  />
                </div>
                <input
                  className="jp-range"
                  type="range"
                  min="0"
                  max="100"
                  step="1"
                  value={seekValue}
                  onChange={(e) => {
                    const seekto =
                      this.audioPlayer.current.duration *
                      (+e.target.value / 100);
                    this.audioPlayer.current.currentTime = seekto;
                    this.setState({
                      seekValue: parseInt(e.target.value),
                    });
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        ;
      </div>
    );
  }
}
